import React from 'react'

import Form from '../../../packages/kiti/components/form/form/Form'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import RedirectionSection from './sections/RedirectionSection'
import ThemeSection from './sections/ThemeSection'
import CompletionSection from './sections/CompletionSection'
import GeneralSection from './sections/GeneralSection'
import { useSaveDynamicServiceOrders } from './_requests/saveDynamicServiceOrders'
import { useDynamicServiceOrder } from './_load/DynamicServiceOrderLoader'
import LevelsLoader from './_load/LevelsLoader'

const EditDynamicServiceOrders = () => {
  const dynamicServiceOrder = useDynamicServiceOrder()
  const [onSubmit, { loading, error }] = useSaveDynamicServiceOrders()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={dynamicServiceOrder}>
      <LevelsLoader>
        <GeneralSection />
      </LevelsLoader>
      <RedirectionSection />
      <ThemeSection />
      <CompletionSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditDynamicServiceOrders
